import { drilldownDataCorporate, ModuleFields } from "~/Utils/drilldownDataDum";

export const mapFields = (data: ModuleFields[]) => {
  return data.map(({ fieldName, placeholder, name, formType, validation, className, hidden, usedFileType }) => ({
    name,
    type: formType,
    label: fieldName,
    placeholder,
    validation,
    className,
    hidden,
    usedFileType
  }));
};

let fields: any = {};

const fieldsReady = new Promise(async (resolve, reject) => {
  try {
    const data = await drilldownDataCorporate();
    console.log("constantdatadum", data);
    fields = {
      nextPageOurPolicies: mapFields(data?.nextPageOurPolicies),
      malaysiaAirportsHoldingsBerhadOurPolicies: data?.malaysiaAirportsHoldingsBerhadOurPolicies?.map((data: ModuleFields[])=>{
        return mapFields(data);
      }),
      subsidiariesOurPolicies: data?.subsidiariesOurPolicies?.map((data: ModuleFields[])=>{
        return mapFields(data);
      }),
      overseasOurAirports: data?.overseasOurAirports?.map((data: ModuleFields[])=>{
        return mapFields(data);
      }),
      stolportsOurAirports: data?.stolportsOurAirports?.map((data: ModuleFields[])=>{
        return mapFields(data);
      }),
      domesticOurAirports: data?.domesticOurAirports?.map((data: ModuleFields[])=>{
        return mapFields(data);
      }),
      internationalOurAirports: data?.internationalOurAirports?.map((data: ModuleFields[])=>{
        return mapFields(data);
      }),
      ourProfile: data?.ourProfile?.map((data: ModuleFields[])=>{
        return mapFields(data);
      }),
      ourBrandPageContent: mapFields(data?.ourBrandPageContent),
      ourBrandPageHeading: mapFields(data?.ourBrandPageHeading),
      ourPoliciesPageHeading: mapFields(data?.ourPoliciesPageHeading),
      ourAirportsPageHeading: mapFields(data?.ourAirportsPageHeading),
      ourProfilePageHeading: mapFields(data?.ourProfilePageHeading),
      ourBrandNextPage: mapFields(data?.ourBrandNextPage)
    };
    console.log("constantsdum", fields);
    resolve(fields); 
  } catch (error) {
    console.error("Error accessing drilldown data:", error);
    reject(error); 
  }
});

export { fields, fieldsReady };
